import React from 'react'
import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(3),
    },
    col: {},
    md5: {
      [theme.breakpoints.up('lg')]: {
        maxWidth: '20%',
        flexBasis: '20%',
      },
    },
  })
)

type Tprops = {
  aspectRatio: string
  gridItemWidth: any
  isFiveColumns: boolean
}

const ProductCardSkeleton = ({
  isFiveColumns,
  gridItemWidth,
  aspectRatio,
}: Tprops) => {
  const classes = useStyles()
  return (
    <>
      <Grid container spacing={3} className={classes.root}>
        {Array.from(new Array(5)).map((el, index) => {
          return (
            <Grid
              item
              xs={6}
              key={index}
              lg={isFiveColumns ? 2 : gridItemWidth}
              className={isFiveColumns ? classes.md5 : classes.col}
            >
              <div>
                <Skeleton data-ratio={aspectRatio} variant="rect" />
                <Skeleton variant="text" width="16ch" />
                <Skeleton variant="text" width="5ch" />
              </div>
            </Grid>
          )
        })}
      </Grid>
    </>
  )
}

export default ProductCardSkeleton
